import React from "react";
import styled from "styled-components";
import { Icon } from "../../../Icon";
import { CarouselTrigger } from "../CarouselTrigger";
import { mixinSkins } from "../../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../../skins/types";
import { riotProductSkin } from "./skins/riot-product";
import { riotLionSkin } from "./skins/project-l";
const _CarouselPrevious = ({ className }) => {
    return (React.createElement(CarouselTrigger, { to: "previous", className: `prev ${className}` },
        React.createElement(Icon, { name: "carouselLeft" })));
};
export const CarouselPrevious = styled(_CarouselPrevious) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
    [SkinId.RiotProductLion]: riotLionSkin,
})}
`;
//# sourceMappingURL=index.js.map